<section class="applied-jobs-page">
  <header class="page-header">
    <h1>{{ 'appliedJobs.title' | translate }}</h1>
    <p>{{ 'appliedJobs.subtitle' | translate }}</p>
  </header>

  <div class="stats-grid" aria-label="Application statistics">
    <article class="stat-card">
      <div class="stat-top">
        <span>{{ 'appliedJobs.totalApplications' | translate }}</span>
        <i class="bi bi-clipboard"></i>
      </div>
      <strong>{{ statistics.totalApplications }}</strong>
    </article>
    <article class="stat-card">
      <div class="stat-top">
        <span>{{ 'appliedJobs.interviews' | translate }}</span>
        <i class="bi bi-chat-square"></i>
      </div>
      <strong>{{ statistics.interviews }}</strong>
    </article>
    <article class="stat-card stat-card--accent">
      <div class="stat-top">
        <span>{{ 'appliedJobs.acceptanceRate' | translate }}</span>
        <i class="bi bi-graph-up-arrow"></i>
      </div>
      <strong>{{ statistics.acceptanceRate }}%</strong>
    </article>
    <article class="stat-card">
      <div class="stat-top">
        <span>{{ 'appliedJobs.activeApplications' | translate }}</span>
        <i class="bi bi-lightning-charge"></i>
      </div>
      <strong>{{ statistics.activeApplications }}</strong>
    </article>
  </div>

  <div class="filters-bar">
    <div class="filters-left">

      <!-- Status filter -->
      <div class="filter-dropdown dropdown">
        <button type="button" class="filter-pill dropdown-toggle" [class.filter-pill--active]="hasStatusFilter"
          (click)="toggleStatus($event)" [attr.aria-expanded]="statusOpen">
          <i class="bi bi-filter"></i>
          <span>{{ statusLabel }}</span>
          <i *ngIf="hasStatusFilter" class="bi bi-x filter-pill__clear" (click)="clearStatus($event)"></i>
        </button>
        <ul class="dropdown-menu" *ngIf="statusOpen" (click)="stopProp($event)" [class.show]="statusOpen">
          <li *ngFor="let opt of statusOptions" class="dropdown-item"
            [class.dropdown-item--selected]="filters.status === opt.value" (click)="selectStatus($event, opt.value)">{{
            opt.label }}</li>
        </ul>
      </div>

      <!-- Job Type filter -->
      <div class="filter-dropdown dropdown">
        <button type="button" class="filter-pill dropdown-toggle" [class.filter-pill--active]="hasJobTypeFilter"
          (click)="toggleJobType($event)" [attr.aria-expanded]="jobTypeOpen">
          <span>{{ jobTypeLabel }}</span>
          <i *ngIf="hasJobTypeFilter" class="bi bi-x filter-pill__clear" (click)="clearJobType($event)"></i>
        </button>
        <ul class="dropdown-menu" *ngIf="jobTypeOpen" (click)="stopProp($event)" [class.show]="jobTypeOpen">
          <li *ngFor="let opt of jobTypeOptions" class="dropdown-item"
            [class.dropdown-item--selected]="filters.jobType === opt.value" (click)="selectJobType($event, opt.value)">
            {{ opt.label }}</li>
        </ul>
      </div>

      <!-- Date Applied filter -->
      <div class="filter-dropdown">
        <button type="button" class="filter-pill filter-pill--date" [class.filter-pill--active]="hasDateFilter"
          (click)="toggleDate($event)">
          <i class="bi bi-calendar3"></i>
          <span>{{ dateLabel }}</span>
          <i *ngIf="hasDateFilter" class="bi bi-x filter-pill__clear" (click)="clearDate($event)"></i>
        </button>
        <div class="dropdown-menu dropdown-menu--calendar" *ngIf="dateOpen" (click)="stopProp($event)">
          <div class="flatpickr-inline-container"></div>
        </div>
      </div>

    </div>


  </div>

  <div class="job-list">
    <article *ngFor="let job of jobs" class="job-card" [class.job-card--highlighted]="job.highlighted">
      <div class="job-logo" [style.background]="job.logoBg" [style.color]="job.logoColor">
        <img *ngIf="job.companyLogoUrl; else logoLetter" [src]="job.companyLogoUrl" [alt]="job.company"
          style="width:100%;height:100%;object-fit:contain;border-radius:6px;" />
        <ng-template #logoLetter>{{ job.logoLetter }}</ng-template>
      </div>

      <div class="job-main">
        <div class="job-title-row">
          <h2>{{ job.jobPostTitle }}</h2>
          <span *ngIf="job.location" class="job-tag job-tag--location">{{ job.location }}</span>
          <span *ngIf="job.badge" class="job-tag job-tag--match">
            <i class="bi bi-stars"></i>{{ job.badge }}
          </span>
        </div>
        <p class="job-meta">
          <strong>{{ job.company }}</strong>
          <span></span>
          {{ 'appliedJobs.applied' | translate }} {{ job.appliedDate }}
          <ng-container *ngIf="job.status === 'Selected For Interview' && job.interviewExpirationDate">
            <span></span>
            <span class="job-expiry">
              <i class="bi bi-clock"></i>
              Interview ends {{ formatInterviewExpiry(job.interviewExpirationDate) }}
            </span>
          </ng-container>
        </p>
      </div>

      <div class="job-actions">
        <ng-container *ngIf="job.status === 'Selected For Interview'; else defaultStatusBadge">
          <ng-container *ngIf="job.interviewUrl; else missingInterviewLink">
            <a class="action-button action-button--success" [href]="job.interviewUrl" rel="noopener noreferrer">
              Selected - Start Your Interview
            </a>
          </ng-container>
          <ng-template #missingInterviewLink>
            <button type="button" class="action-button action-button--neutral" disabled>
              Waiting for Result
            </button>
          </ng-template>
        </ng-container>
        <ng-template #defaultStatusBadge>
          <span class="status-badge" [ngClass]="getStatusClass(job.status)">{{ job.status }}</span>
        </ng-template>

        <button type="button" class="action-button action-button--primary" (click)="viewJob(job.jobPostId)">
          {{ 'appliedJobs.viewJob' | translate }}
        </button>
      </div>
    </article>
  </div>

  <!-- Pagination -->
  <nav class="pagination" aria-label="Applied jobs pagination">
    <button type="button" class="page-button page-button--arrow" aria-label="Previous page"
      [disabled]="currentPage === 1" (click)="previousPage()"><i class="bi bi-chevron-left"></i></button>

    <button *ngFor="let page of visiblePages" type="button" class="page-button"
      [class.page-button--active]="page === currentPage" [attr.aria-current]="page === currentPage ? 'page' : null"
      (click)="goToPage(page)">{{ page }}</button>

    <ng-container *ngIf="showEndEllipsis">
      <span class="pagination-dots">…</span>
      <button type="button" class="page-button" [class.page-button--active]="totalPages === currentPage"
        (click)="goToPage(totalPages)">{{ totalPages }}</button>
    </ng-container>

    <button type="button" class="page-button page-button--arrow" aria-label="Next page"
      [disabled]="currentPage >= totalPages" (click)="nextPage()"><i class="bi bi-chevron-right"></i></button>
  </nav>
</section>
